import {Box, LinearProgress, Typography} from '@mui/material';
import { Template } from '@pdfme/common';

const JSONMemoryLimitProgress = ({ jsonData, maxMB = 10 }: { jsonData: Template | null; maxMB?: number }) => {
    const jsonString = JSON.stringify(jsonData);
    const sizeInBytes = new TextEncoder().encode(jsonString).length;
    const sizeInMB = sizeInBytes / (1024 * 1024);
    const percentage = Math.min((sizeInMB / maxMB) * 100, 100);
    const isTooLarge = sizeInMB > maxMB;

    return (
        <Box sx={{width: '50%'}}>
            <Box display="flex" alignItems="center">
                <Box width="100%" mr={1}>
                    <LinearProgress
                        variant="determinate"
                        value={percentage}
                        color={isTooLarge ? "error" : "primary"}
                    />
                </Box>
                <Box minWidth={35}>
                    <Typography variant="body2" color={isTooLarge ? "error" : "textSecondary"}>
                        {`${Math.round(percentage)}%`}
                    </Typography>
                </Box>
            </Box>
            <Typography variant="body2" color={isTooLarge ? "error" : "textSecondary"} mt={1}>
                {sizeInMB.toFixed(3)} MB / {maxMB} MB
            </Typography>
        </Box>
    );
};

export default JSONMemoryLimitProgress;
